import ScrollReveal from "./ScrollReveal";
import { Button } from "@/components/ui/button";
import {
  MessageCircle, Building2, DollarSign, FileSearch, PenTool,
  CalendarCheck, Clock, Handshake, Home, FileText, Bell, FolderOpen, Award,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";

const services: { title: string; desc: string; Icon: LucideIcon }[] = [
  { title: "Communication", desc: "Contact all parties and introduce ourselves as your Transaction coordinator, as well as deliver the REPC to all parties involved in the transaction.", Icon: MessageCircle },
  { title: "Title and Escrow Coordination", desc: "Our service includes coordinating with your Title company and escrow officer regarding title work, and organizing and scheduling closings.", Icon: Building2 },
  { title: "Earnest Money Management", desc: "Timely reminders about earnest money, including confirmation of receipt to all involved parties.", Icon: DollarSign },
  { title: "Document Review for Accuracy", desc: "Review purchase agreement, counter offers, all addendums. Ensure everything is fully executed with proper dates, initials, signatures, etc.", Icon: FileSearch },
  { title: "Electronic Signature Management", desc: "We facilitate the electronic signing of all necessary addendums, broker-required forms, repair addendums, and other relevant documents.", Icon: PenTool },
  { title: "Appointment Scheduling", desc: "We coordinate and schedule all your appointments. I.E. home inspections, Final Walk through, and closings with homeowners and agents for a smooth execution.", Icon: CalendarCheck },
  { title: "Deadline Date Updates", desc: "We provide systematic update reminders to all parties for critical deadline dates.", Icon: Clock },
  { title: "Lender Coordination", desc: "Active coordination with your lender to keep you informed about your client's loan status.", Icon: Handshake },
  { title: "Pre-Move Coordination", desc: "Assistance in coordinating with your clients regarding pre-move tasks, offering timely reminders for all necessary preparations.", Icon: Home },
  { title: "Seller Property Condition Disclosures", desc: "We ensure the Seller Disclosures are delivered to the buyers and listing agent, as well as ensure that all contract time-lines are adhered to. Efficient handling of E-signature processes of the Seller Property Condition Disclosures when representing the Sellers, and then we deliver them to the buyers agent after being signed by your sellers.", Icon: FileText },
  { title: "Proactive Communication System", desc: "We employ a time-sensitive communication system, including text reminders, to keep all parties updated and ahead of deadlines and tasks.", Icon: Bell },
  { title: "Document Management", desc: "Our system uploads all necessary documents, disclosures, and reports into our transaction management software in real-time, ensuring accurate and timely record-keeping throughout the transaction process.", Icon: FolderOpen },
  { title: "Closing Guarantee", desc: "Our confidence in our service is reflected in our closing guarantee - if a transaction does not close, there is no charge to you.", Icon: Award },
];

const Services = () => {
  const navigate = useNavigate();
  
  return (
    <section id="services" className="py-24 px-4 bg-card/50">
      <div className="max-w-7xl mx-auto">
        <ScrollReveal>
          
          {/* Elementor-Style Text Divider */}
          <div className="flex items-center justify-center gap-4 mb-4 max-w-md mx-auto">
            {/* Left Line */}
            <div className="h-[2px] bg-primary/20 flex-1 rounded-full"></div>
            {/* Divider Text */}
            <h3 className="text-primary font-bold uppercase tracking-[0.2em] text-sm md:text-base whitespace-nowrap">
              Quality Service
            </h3>
            {/* Right Line */}
            <div className="h-[2px] bg-primary/20 flex-1 rounded-full"></div>
          </div>
          
          {/* Main Heading */}
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-foreground mb-16 text-center">
            Our Services . . .
          </h2>

        </ScrollReveal>
        
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => (
            <ScrollReveal key={s.title} delay={i * 0.05}>
              <div className="bg-card border border-border rounded-xl p-8 h-full transition-all duration-300 group hover:bg-primary hover:border-primary hover:shadow-xl hover:-translate-y-1 flex flex-col items-center text-center sm:items-start sm:text-left">
                <s.Icon className="h-12 w-12 mb-6 text-primary transition-colors duration-300 group-hover:text-white" />
                <h3 className="text-xl font-bold text-foreground mb-3 transition-colors duration-300 group-hover:text-white">
                  {s.title}
                </h3>
                <p className="text-muted-foreground text-sm leading-relaxed transition-colors duration-300 group-hover:text-white/90">
                  {s.desc}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
        
        <ScrollReveal delay={0.2}>
          <div className="text-center mt-16">
            <Button 
              size="lg" 
              className="text-lg px-10 py-6"
              onClick={() => {
                navigate("/get-started");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            >
              Get Services
            </Button>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default Services;